const exportedObject = {
  getZonasData: [],
  getZonasLoading: false,
  getZonasError: null,

  getProvinciasData: [],
  getProvinciasLoading: false,
  getProvinciasError: null,

  getDiagnosticosData: [],
  getDiagnosticosLoading: false,
  getDiagnosticosError: null,

  getGruposData: [],
  getGruposLoading: false,
  getGruposError: null,

  getDepartamentosData: [],
  getDepartamentosLoading: false,
  getDepartamentosError: null,
};

export default exportedObject;
